import FetchBase from '../Api/FetchBase'
import { observable, action } from 'mobx'
import {
  API_ENDPOINTS,
  SUBSCRIPTION_PLAN_KEYS,
  SUBSCRIPTION_CONFIG_WITH_PERMISSION,
  COOKIE_SET_TIMER,
  PORTAL_RESTRICTION,
} from '../Utils/constants'
import { COOKIE_STOAGE } from '../Utils/Storage'
import { checkBoolean } from '../Utils/helpers'

export default class PermissionsStore extends FetchBase {
  @observable permissionsLoader = true
  @observable permissions = undefined
  @observable currentOrg = undefined
  @observable resellerId = undefined
  @observable adminRole = []
  @observable usageLimit = {}
  @observable usage = {}
  @observable planPermission = undefined
  @observable isAllow = false
  @observable isCompletedOnboard = COOKIE_STOAGE.getItem('isCompletedOnboard')

  // features set with perimssion and subscription
  featuresOFPermissionWithSubscription = (permission, feature) => {
    if (feature) {
      switch (permission?.operationId) {
        case SUBSCRIPTION_CONFIG_WITH_PERMISSION?.ACTIONITEMS: //Action item features ( widget and pages )
          return feature?.ACTIONITEMS?.CAN_ALLOW && permission?.canView
        case SUBSCRIPTION_CONFIG_WITH_PERMISSION?.COMMENTS: // Comment features ( widget and pages )
          return feature?.COMMENTS?.CAN_ALLOW && permission?.canView
        case SUBSCRIPTION_CONFIG_WITH_PERMISSION?.DASHBOARD: // Main dashboard ( features )
          return feature?.DASHBOARD?.CAN_ALLOW && permission?.canView
        case SUBSCRIPTION_CONFIG_WITH_PERMISSION?.INTERNALNOTES: // Internal notes features ( widget and pages )
          return feature?.INTERNALNOTES?.CAN_ALLOW && permission?.canView
        case SUBSCRIPTION_CONFIG_WITH_PERMISSION?.SYSTEMROLES: // config Roles features ( widget and pages )
          return feature?.SYSTEMROLES?.CAN_ALLOW && permission?.canView
        case SUBSCRIPTION_CONFIG_WITH_PERMISSION?.PROJECTROLES: // Project Roles features ( widget and pages )
          return feature?.PROJECTROLES?.CAN_ALLOW && permission?.canView
        case SUBSCRIPTION_CONFIG_WITH_PERMISSION?.REPORTINGTAB: // Reporting features ( widget and pages )
          return feature?.REPORTINGTAB?.CAN_ALLOW && permission?.canView
        case SUBSCRIPTION_CONFIG_WITH_PERMISSION?.SPACESPERPROJECT: // Project Space features ( widget and pages )
          return feature?.SPACESPERPROJECT?.CAN_ALLOW && permission?.canView
        case SUBSCRIPTION_CONFIG_WITH_PERMISSION?.TASKPERSPACE: // Project Space Task features ( widget and pages )
          return feature?.TASKPERSPACE?.CAN_ALLOW && permission?.canView
        case SUBSCRIPTION_CONFIG_WITH_PERMISSION?.PROJECT_DOCUMENT: // Project Attachment features ( widget and pages )
        case SUBSCRIPTION_CONFIG_WITH_PERMISSION?.CUSTOMER_DOCUMENT: // Project Customer attachment features ( widget and pages )
        case SUBSCRIPTION_CONFIG_WITH_PERMISSION?.PROJECT_SPACE_TASK_IMAGE: // Project Task image attachment features ( widget and pages )
          return (
            feature?.DOCUMENTATIONREPOSITORY?.CAN_ALLOW && permission?.canView
          )

        default:
          // default which is not listed in subscription
          return permission?.canView
      }
    } else {
      return permission?.canView
    }
  }

  reStructurePermissions = (permissions, features, isAllow) => {
    let temp = {}
    ;(permissions || []).forEach((permission) => {
      let canAllow = this.featuresOFPermissionWithSubscription(
        permission,
        features
      )
      let t = {
        CAN_DELETE: (canAllow && isAllow && permission?.canDelete) || false,
        CAN_MODIFY: (canAllow && isAllow && permission?.canModify) || false,
        // CAN_VIEW: permission?.canView || false, // have commented because below code implement permission with subscription
        CAN_VIEW: (canAllow && isAllow) || false, // we are checking same permission is allowed or not allowed subscription
      }
      let name = permission?.operations?.name || ''
      name = name?.split(' ') || []
      name = name.join('_') || ''
      temp[name.toUpperCase()] = t
    })
    return temp
  }

  // Define Structure of subscription key based on allowed and not allowed key
  reStructureSubscriptionFeatures = (features) => {
    let temp = {}
    ;(features || []).forEach((feature) => {
      // If not allow ( -2 ) means false otherwise true ( -1 is true ) but we allow if you have 0<= value
      let isAccess =
        feature?.value === SUBSCRIPTION_PLAN_KEYS.CAN_NOT_ALLOW ? false : true
      let t = {
        CAN_ALLOW: isAccess,
      }
      let name = feature?.name || ''
      name = name?.split(' ') || []
      name = name.join('_') || ''
      temp[name.toUpperCase()] = t
    })
    return temp
  }

  // Define Structure of subscription limit in Boolean
  reStructureSubscriptionLimit = (features) => {
    let temp = {}
    let limitKeys = Object.keys(features)
    for (let key of limitKeys) {
      let featureLimit = features[key]
      let t = {
        ALLOW:
          featureLimit?.currentValue < featureLimit?.limit ||
          featureLimit?.limit === SUBSCRIPTION_PLAN_KEYS?.UNLIMITED ||
          featureLimit?.limit === SUBSCRIPTION_PLAN_KEYS?.UNLIMITED_YES
            ? true
            : false,
      }
      let name = `${key}_CAN` || ''
      temp[name.toUpperCase()] = t
    }

    return temp
  }

  @action.bound
  getPermissions = async () => {
    try {
      if (this.permissions) {
        this.isCompletedOnboard = COOKIE_STOAGE.getItem('isCompletedOnboard')
        return [
          true,
          this.permissions,
          this.currentOrg,
          this.adminRole,
          this.planPermission,
          this.usageLimit,
          this.isCompletedOnboard,
        ]
      }
      this.permissionsLoader = true
      let isSuperUser = COOKIE_STOAGE.getItem('isSuperUser')
      isSuperUser = checkBoolean(isSuperUser)

      let response = await this.get(API_ENDPOINTS.GET_PERMISSIONS)
      if (response.status) {
        this.currentOrg = response.data?.organization || {}
        this.adminRole = response.data?.adminRole || []
        this.usage = response?.data?.usage || {}
        this.resellerId = response.data?.resellerInfo?.id

        //if subscription is not active and is not super admin
        let isPortalAccess =
          this.currentOrg?.accessStatus === PORTAL_RESTRICTION?.ACCESS

        let isAllow = isPortalAccess || isSuperUser

        this.planPermission =
          Boolean(response.data?.currentPlan?.length) &&
          this.reStructureSubscriptionFeatures(response.data?.currentPlan || [])
        this.permissions = this.reStructurePermissions(
          response.data?.permissions || {},
          this.planPermission,
          isAllow
        )
        this.usageLimit = this.reStructureSubscriptionLimit(
          response?.data?.usage || {}
        )

        // loca sotrage
        this.isCompletedOnboard =
          response.data?.organization?.completedOnboardId
        let cremember = (COOKIE_STOAGE.getItem('remember') || '') === 'true'
        COOKIE_STOAGE.setItem('isCompletedOnboard', this.isCompletedOnboard, {
          ...(cremember ? { maxAge: COOKIE_SET_TIMER } : {}),
        })

        return [true, response.data?.permissions || [], this.permissions]
      } else {
        this.permissions = undefined
        return [false, undefined, undefined]
      }
    } catch (err) {
      this.permissions = undefined
      this.currentOrg = undefined
      this.adminRole = []
      this.resellerId = undefined
      return [false, undefined, undefined]
    } finally {
      this.permissionsLoader = false
    }
  }

  @action.bound
  setCurrentOrg(data) {
    this.currentOrg['logo'] = data?.logo
  }

  @action.bound
  getUsageToUpdateLimit = async () => {
    try {
      let response = await this.get(API_ENDPOINTS?.GET_USAGE_BY_ORG_ID)

      if (response.status) {
        this.usage = response.data?.usage || {}
        this.usageLimit = this.reStructureSubscriptionLimit(
          response.data?.usage || {}
        )
        return [true, response.data?.usage]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  resetPermissions = () => {
    this.permissionsLoader = false
    this.permissions = undefined
    this.currentOrg = undefined
    this.resellerId = undefined
    this.adminRole = []
    this.usageLimit = {}
    this.usage = {}
    this.planPermission = undefined
    this.isAllow = false
    this.isCompletedOnboard = undefined
  }
}
